import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=9a616f28&scoped=true&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"
import style0 from "./Component.vue?vue&type=style&index=0&id=9a616f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a616f28",
  null
  
)

export default component.exports